export const actionsTakePayload =
    (key) =>
    (state, { payload }) => ({
        ...state,
        [key]: payload,
    });

export const actionsBoolPayload =
    (key) =>
    (state, { payload }) => ({
        ...state,
        [key]: !!payload,
    });

/**
 * It's really cool in Storybook to be able to override Redux props
 */
export const ownPropsPriority = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});
